import FormConditionsPage from './FormConditions.page';

const FormCondition = () => {
  return (
    <div className={`page-wrapper`}>
      <FormConditionsPage />
    </div>
  );
};

export default FormCondition;
